module.exports = __webpack_public_path__ + "static/media/headerTop-Mobile.506c770a.svg";